import styled from '@emotion/styled';
import {
  DeleteOutline,
  DriveFolderUploadOutlined,
  EditOutlined,
  FormatListBulletedOutlined,
} from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import MenuIcon from '@mui/icons-material/Menu';
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import useProductPackagingDelete from 'api/productDetail/useProductPackagingDelete/useProductPackagingDelete';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import ProductPrintSettingsModal from 'components/shared/Modals/productsList/ProductPrintSettingsModal/ProductPrintSettingsModal';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useMemo, useState } from 'react';

import ProductPackagingEditModal from '../../Modals/productsList/ProductPackagingEditModal/ProductPackagingEditModal';
import ProductPackagingInsertModal from '../../Modals/productsList/ProductPackagingInsertModal/ProductPackagingInsertModal';
import PackagePrintModal from '../PrintPackaging';

const packagingPermissions =
  permissions.general.categories.globalSettings.productManagement.productList
    .detail.packaging;

const AccordionPackaging = ({
  packagingList,
  refetchPackagingList,
  getProductDetail,
  branchGuid,
}) => {
  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isPrintSettingModalOpen, setIsPrintSettingModalOpen] = useState(false);
  const [editChosenProduct, setEditChosenProduct] = useState({});
  const [printSettingChosenProduct, setPrintSettingChosenProduct] = useState(
    {},
  );
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  const [chosenPrintProduct, setChosenPrintProduct] = useState({});

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowInfo, setSelectedRowInfo] = useState(null);

  const { can } = usePermissions();

  const openMenu = Boolean(anchorEl);

  const handleClickMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowInfo(row);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRowInfo(null);
  };

  const [deleteRequest] = useProductPackagingDelete();

  const print = useCallback(
    row => () => {
      setChosenPrintProduct(row);
      setIsPrintModalOpen(true);
    },
    [],
  );

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenProduct(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const printSettingItem = useCallback(
    row => () => {
      setPrintSettingChosenProduct(row);
      setIsPrintSettingModalOpen(true);
    },
    [],
  );

  const deleteHandle = id => {
    setDeleteLoading(true);

    deleteRequest(
      id,
      getProductDetail,
      setIsDeleteModalOpen,
      setDeleteLoading,
      refetchPackagingList,
    );
  };

  const menuItems = useMemo(
    () => [
      {
        label: 'حذف',
        permission: packagingPermissions.delete,
        icon: DeleteOutline,
        color: 'error',
        onClick: row => {
          handleCloseMenu();
          deleteItem(row)();
        },
      },
      {
        label: 'ویرایش',
        permission: packagingPermissions.edit,
        icon: EditOutlined,
        color: 'warning',
        onClick: row => {
          handleCloseMenu();
          editItem(row)();
        },
      },
      {
        label: 'تنظیمات چاپ',
        permission: packagingPermissions.printSettings,
        icon: EditOutlined,
        color: 'warning',
        onClick: row => {
          handleCloseMenu();
          printSettingItem(row)();
        },
      },
      {
        label: 'آپلود فایل سریال',
        permission: packagingPermissions.uploadSerialFile,
        icon: DriveFolderUploadOutlined,
        color: 'success',
        onClick: row => {
          handleCloseMenu();

          // TODO: implement upload serial file
          // uploadSerialFile(row);
        },
      },
      {
        label: 'لیست سریال های فعال',
        permission: packagingPermissions.activeSerialList,
        icon: FormatListBulletedOutlined,
        color: 'info',
        onClick: row => {
          handleCloseMenu();

          // TODO: implement active serial list
          // showActiveSerialList(row);
        },
      },
    ],
    [deleteItem, editItem, printSettingItem],
  );

  const visibleMenuItems = useMemo(
    () => menuItems.filter(item => can(item.permission)),
    [menuItems, can],
  );

  const canPrint = can(packagingPermissions.print);

  const canCreate = can(packagingPermissions.create);

  return (
    <Wrapper>
      <Header>
        <Title>لیست پکیج ها</Title>

        {canCreate ? (
          <AddButton
            variant="contained"
            size="small"
            onClick={() => setIsInsertModalOpen(true)}
          >
            <AddIcon />
          </AddButton>
        ) : null}
      </Header>

      <TableContainer>
        <Table sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow
              sx={{
                '& .MuiTableCell-root': {
                  borderColor: 'rgba(100, 100, 100, .2)',
                  background: 'rgba(180, 180, 180, 0.05)',
                },
              }}
            >
              <TableCell
                align="right"
                sx={{
                  width: {
                    xs: 'auto',
                    lg: '450px',
                    xl: '550px',
                  },
                }}
              >
                نام
              </TableCell>

              <TableCell align="right">بسته‌‌ بندی مادر</TableCell>

              <TableCell align="right">تعداد</TableCell>

              <TableCell align="left" width={100}>
                عملیات ها
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {packagingList?.map((packItem, index) => (
              <TableRow key={packItem.id ?? index}>
                <TableCell align="right">{packItem.title}</TableCell>

                <TableCell align="right">{packItem.motherPack}</TableCell>

                <TableCell align="right">{packItem.count}</TableCell>

                <TableCell align="right" width={180}>
                  <ActionContainer>
                    {canPrint ? (
                      <Button
                        variant="contained"
                        color="info"
                        size="small"
                        onClick={() => {
                          handleCloseMenu();
                          print(packItem)();
                        }}
                      >
                        پرینت
                      </Button>
                    ) : null}

                    {visibleMenuItems.length > 0 && (
                      <div>
                        <IconButton
                          id={`${packItem.title}-button`}
                          aria-controls={
                            openMenu ? `${packItem.title}-menu` : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={openMenu ? 'true' : undefined}
                          onClick={e => handleClickMenu(e, packItem)}
                        >
                          <MenuIcon />
                        </IconButton>
                      </div>
                    )}
                  </ActionContainer>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Menu
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleCloseMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          {visibleMenuItems.map(item => {
            const Icon = item.icon;

            return (
              <MenuItem
                key={item.permission}
                onClick={() => item.onClick(selectedRowInfo)}
              >
                <Action>
                  <Typography fontSize={14}>{item.label}</Typography>

                  <Icon fontSize="small" color={item.color} />
                </Action>
              </MenuItem>
            );
          })}
        </Menu>
      </TableContainer>

      {isInsertModalOpen ? (
        <ProductPackagingInsertModal
          open={isInsertModalOpen}
          branchGuid={branchGuid}
          refetchPackagingList={refetchPackagingList}
          handleClose={() => setIsInsertModalOpen(false)}
        />
      ) : null}

      {isEditModalOpen ? (
        <ProductPackagingEditModal
          open={isEditModalOpen}
          branchGuid={branchGuid}
          packGuid={editChosenProduct.id}
          refetchPackagingList={refetchPackagingList}
          handleClose={() => setIsEditModalOpen(false)}
        />
      ) : null}

      <DeleteModal
        open={isDeleteModalOpen}
        handleClose={() => setIsDeleteModalOpen(false)}
        title={deleteChosenLocation.title}
        locationId={deleteChosenLocation.id}
        deleteLoading={deleteLoading}
        onDelete={deleteHandle}
      />

      {isPrintSettingModalOpen ? (
        <ProductPrintSettingsModal
          open={isPrintSettingModalOpen}
          branchGuid={branchGuid}
          packGuid={printSettingChosenProduct.id}
          handleClose={() => setIsPrintSettingModalOpen(false)}
        />
      ) : null}

      <PackagePrintModal
        open={isPrintModalOpen}
        setOpen={() => setIsPrintModalOpen(false)}
        guid={chosenPrintProduct?.id}
      />
    </Wrapper>
  );
};

export default AccordionPackaging;

const Wrapper = styled.div`
  margin-top: 50px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 12px;
`;

const ActionContainer = styled(Header)`
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const Title = styled.h4``;

const AddButton = styled(Button)`
  background-color: #27348b;
`;

const Action = styled(Box)({
  paddingTop: '0.3rem',
  paddingBottom: '0.3rem',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '0.5rem',
});

const TableContainer = styled.div``;
